import React from 'react'

function Revs_web() {
  return (
    <div className='revs_web'>
   
    <div className='revs_part'>
    
        <div className='reviewrs'>
           <div className='PP_REV'></div>
           <div className='name_rev'>
            <p className='rev_Email'>kevinukoya@gmail.com</p>
            <p className='rev_Words'>This site is great!! I have never felt dissapointed</p>
           </div>
        </div>
    </div>
    <div className='text_area_place'>
      <textarea placeholder='write reviews'></textarea>
      <div className='go_btn'>Go</div>
    </div>

</div>
  )
}

export default Revs_web